export default {
  "home": "首頁",
  "ai": "AI開放平台首頁",
  "deepcam": "神目科技官網",
  "experience": "線上體驗",
  "learn": "學習中心",
  "login": "登錄",
  "register": "註冊",
  "app": "應用管理",
  "adminapp": "應用管理",
  "device": "應用設備",
  "sdk": "SDK中心",
  "sdkList":"SDK列表",
  "sdkFiles":"SDK文件",
  "announcement": "公告中心",
  "personal": "個人中心",
  "user": "用戶管理",
  "sdkManagement": "SDK管理",
  "relationship": "設置關聯",
  "screen": "全屏",
  "outScreen": "退出全屏",
  "quit": "安全退出",
  "appList": "應用列表",
  "warrant": "授權文件列表",
  "global": {
    "not": "不能為空",
    "rules1": "密碼只能輸入6~16位字符，且不能出現空格",
    "rules2": "郵箱格式不正確",
    "rules3": "手機格式不正確",
    "input2": "請輸入密碼",
    "input3": "請再次輸入密碼",
    "input4": "請輸入郵箱",
    "input5": "請輸入手機號",
    "pswDifferent": "兩次輸入的密碼不一致",
    "label1": "是否激活",
    "on": "激活",
    "off": "不激活",
    "cancel": "取消",
    "confirm": "確定",
    "prompt": "提示",
    "label2": "sdk名稱",
    "label3": "SDK類型",
    "label4": "請選擇",
    "label8": "創建時間",
    "label9": "更新時間",
    "label10": "操作",
    "title1": "編輯",
    "title3": "刪除",
    "add": "新增",
    "search": "搜索",
    "contactUs": "聯繫我們",
    "copyright": "版權所有©2018 神目科技（中國） [鄂ICP備18001234號-2]",
    //添加
    "rule4":"必須是整數",
    "loadFail1": "只能上傳.txt格式的文件",
    "loadFail3": "只能上傳.rar,.zip格式的文件",
    "loadFail4": "文件必須小於300MB",
    "loadFail2": "請選擇mac文件進行上傳",
    "err401":"您沒有瀏覽這個頁面的權限",
    "err404":"您的頁面好像飛走了",
    "err500":"鬼知道服務器經歷了什麼",
    "back": "返回首頁",
    "prve":"返回上一頁",
    "admin": "管理員",
    "enterprise":"企業用戶"
  },
  "publicHome": {
    "title1": {
      "title": "基於自主專利技術，提供AI服務",
      "iconName0": "人臉檢測",
      "iconName1": "人臉跟踪",
      "iconName2": "人臉比對",
      "iconName3": "活體檢測",
      "iconName4": "年齡屬性",
      "iconName5": "性別屬性"
    },
    "title2": {
      "title": "滿足多行業場景需求，我們切身實踐",
      "iconName0": "智能樓宇",
      "iconName1": "智慧安防",
      "iconName2": "智慧零售",
      "iconName3": "智慧教育",
      "iconName4": "智慧旅遊",
      "iconName5": "智能機器人"
    },
    "title3": {
      "title": "我們的優勢",
      "iconName0": "技術能力",
      "iconContent0": "由來自卡內基梅隆大學及全國領先生物識別研究所等世界一流團隊傾心打造",
      "iconName1": "準確度",
      "iconContent1": "經過行業商用場景千錘百煉，更領先的精準度",
      "iconName2": "適應性強",
      "iconContent2": "各種複雜環境下的強魯棒性，在多種設備上擁有強勁性能表現"
    },
    "title4": {
      "title": "支持的平台與配",
      "Windows": "<p>最低硬件配置（可運行算法）</p><p class=\"gray\">Intel® CoreTM i5-2300@2.80GHz 或者同級別芯片</p><p>推薦硬件配置（具有良好的體驗）</p><p class=\"gray\">Intel® CoreTMi7-4600U@2.1GHz 或者同級別芯片</p><p>系統版本要求</p ><p class=\"gray\">Windows 7 及以上</p>",
      "Android": "<p>推薦硬件配置（具有良好的體驗）</p><p class=\"gray\" > RK3288、 RK3399或者同級別芯片 </p><p>系統版本要求</p> <p class = \"gray\">Android 5.0 及以上</p>",
      "Linux": "<p>最低硬件配置（可運行算法）</p><p class=\"gray\">Intel® CoreTM i3-4330 Processor</p><p>推薦硬件配置（具有良好的體驗）</p> <p class=\"gray\">Intel® CoreTM i7-5775R Processor</p><p>系統版本要求</p><p class=\"gray\">Ubuntu 14.04及以上</p>",
      "IOS": "<p>最低硬件配置（可運行算法）</p><p class=\"gray\">Apple A7</p><p>推薦硬件配置（具有良好的體驗）</p><p class=\"gray\">Apple A9</p><p>系統版本要求</p><p cl ass=\"gray\">iOS 8.0 及以上</p>"
    },
    "title5": {
      "title": "人臉識別產品免費開放",
      "mark": "等待您的加入",
      "join": "立即加入"
    },
    "footer": {
      "followUs": "關注我們",
      "address": "地址",
      "addressDes": "深圳市龍華區觀湖街道松元廈社區虎地排117號錦繡大地7號樓401",
      "phone": "電話",
      "mail": "郵箱",
      "sendmail": "發送郵箱",
      "shenzhen": "（深圳）",
      "wuhan": "（武漢）"
    }
  },
  "webPage": {
    "login": {
      "input1": "請輸入賬號/手機號",
      "input3": "記住密碼",
      "sub": "登錄",
      "goReg": "去註冊",
      "goHome": "返回首頁"
    },
    "oblivion": {
      "title":"忘記密碼",
      "input1": "確認",
      },
    "register": {
      "input1": "請輸入賬號",
      "input6": "請輸入手機六位驗證碼",
      "getCode": "獲取驗證碼",
      "sub": "註冊",
      "golog": "去登錄",
      "goHome": "返回首頁",
      "rules4": "驗證碼輸入不完整",
      "failCode": "驗證碼獲取失敗",
      "confirmPhone": "請輸入正確的手機號碼"
    },
    "app": {
      "label1": "應用名稱",
      "label4": "包名",
      "label5": "使用時間",
      "label6": "狀態",
      "label7": "創建時間",
      "title1": "下載SDK",
      "title2": "查看設備",
      "title3": "編輯應用信息",
      "label10": "是否激活",
      "note1": "此操作將永久刪除該應用, 是否繼續？ ",
      "loadFail": "請先激活設備再下載",
      //添加
      "label2":"最大激活數量",
      "label3":"到期時間"
    },
    "device": {
      "return": "返回",
      "note1": "此操作將永久刪除該設備, 是否繼續？ "
    },
    "sdk": {
      "add": "新建應用",
      "title1": "創建應用",
      "label1": "app名",
      "label2": "包名",
      "label3": "mac文件",
      "label4": "mac開始",
      "label5": "mac結束",
      "label6": "使用場景",
      "label7": "使用行業",
      "label8": "是否激活",
      "input1": "請輸入app應用名稱",
      "note": "例如",
      "select": "選取文件",
      "input2": "請輸入mac範圍的開始",
      "input3": "請輸入mac範圍的結束",
      "customize": "（定制）"
    },
    "personal": {
      "title1": "基本信息",
      "title2": "用戶名",
      "title3": "用戶ID",
      "title4": "手機號",
      "title5": "郵箱",
      "title6": "新密碼",
      "title7": "確認密碼",
      "title8": "保存修改",
      "label1": "是否修改密碼",
      "pswUpdate": "密碼已更新，請重新登錄"
    }
  },
  "adminPage": {
    "user": {
      "userType": "請選擇用戶類型",
      "label1": "高級用戶",
      "label2": "企業用戶",
      "input1": "請輸入用戶名",
      "input2": "請輸入用戶手機號",
      "input3": "請輸入用戶郵箱",
      "label3": "用戶名",
      "label4": "手機號",
      "label5": "郵箱",
      "label6": "類型",
      "label7": "狀態",
      "title2": "重置密碼",
      "title4": "創建",
      "label11": "用戶類型",
      "note1": "此操作將重置密碼, 是否繼續？ ",
      "note2": "此操作將永久刪除該用戶, 是否繼續？ ",
      "re​​set": "密碼重置成功，默認密碼為123456",
      "re​​setFail": "密碼重置失敗",
      "input4": "請輸入有效時間(月)",
      //添加
      "input5":"mac最大數量（最多85個）",
      "input6":"企業用戶可以註冊的用戶數量",
      "input7": "用戶可創建的app數量",
      "input8": "高級用戶可以註冊的用戶數量",
      "rule2": "請輸入0~85之間的整數",
      "label8": "密碼",
      "label9": "確認密碼",
      "label10": "有效時間",
      "label12": "用戶數量",
      "label13": "app數量",
      "label14": "Mac數量",
      "label15": "普通用戶"
    },
    "app": {
      "title": "創建",
      "label1": "應用名稱",
      "label2": "AppKey數量"
    },
    "sdk": {
      "userType": "請選擇用戶",
      "sdkType": "請選擇sdk類型",
      "label3": "SDK加密方式",
      "title1": "編輯SDK",
      "title2": "創建SDK",
      "label5": "Sdk路徑",
      "label6": "永久激活",
      "label7": "賬號類型",
      "note1": "此操作將永久刪除該SDK, 是否繼續？ ",
      "note2": "此操作將永久刪除該SDK文件，是否繼續？",
      "label1":"文件名",
      "label2":"文件地址",
      "label4":"狀態",
      "text1":"已删除",
      "text2":"正常",
    },
    "association": {
      "userType": "請選擇用戶",
      "sdkType": "請選擇sdk",
      "label1": "用戶名",
      "title1": "創建賬戶與SDK的關聯",
      "note1": "此操作將永久刪除該user與sdk對應信息, 是否繼續？ "
    }
  }
}



// WEBPACK FOOTER //
// ./src/locale/lang/zh-TW.js